import {
  AuthenticationResult,
  BrowserCacheLocation,
  Configuration,
  InteractionRequiredAuthError,
  PublicClientApplication,
  SilentRequest,
} from "@azure/msal-browser";
import * as Sentry from "@sentry/react";

export const ApiScope = "https://api.dsit.ouihelp.fr/Main";

const configuration: Configuration = {
  auth: {
    clientId: "40a9e253-0508-43cc-8aa3-d165502bff47",
    authority: "https://login.microsoftonline.com/f907685c-8d81-492b-ae7b-fbeff9057dd4",
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
  },
};

const publicClientApplication = new PublicClientApplication(configuration);

const getCreateSessionAccessToken = async (): Promise<AuthenticationResult> => {
  const request: SilentRequest = {
    scopes: [ApiScope],
  };

  try {
    return await publicClientApplication.acquireTokenSilent(request);
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      console.log('Silent "acquire token" failed', error);
      return await publicClientApplication.acquireTokenPopup(request);
    }
    throw error;
  }
};

export type JobType = {
  value: string;
  label: string;
  group: string;
  assignable: boolean;
};

export type AgencyOptionType = { value: string; label: string };

export const AppConfig: {
  baseUrl: string;

  // MSAL section
  publicClientApplication: PublicClientApplication;
  getCreateSessionAccessToken: () => Promise<AuthenticationResult>;
  logout: () => void;
} = {
  baseUrl: import.meta.env.VITE_API_BASE_URL,
  publicClientApplication,
  getCreateSessionAccessToken,
  logout: () => {
    // Clear Sentry user context on logout
    if (import.meta.env.PROD) {
      Sentry.setUser(null);
    }
    void publicClientApplication.logoutRedirect({
      onRedirectNavigate: () => false,
    });
  },
};
